import { useGetRefundRequests } from "@/api/refund/get-refund-requests";
import NoDataFound from "@/components/layout/no-data-found";
import PageWrapper from "@/components/layout/page-wrapper";
import { Card } from "@/components/ui/card";
import PaginationCombo from "@/components/ui/pagination-combo";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatDate } from "@/lib/utils";
import { Link, useSearchParams } from "react-router";

const RefundRequests = () => {
    const [searchParams] = useSearchParams();
    const {
        data: requests,
        isLoading,
        isError,
    } = useGetRefundRequests({
        skip: (parseInt(searchParams.get("page") || "1") - 1) * parseInt(searchParams.get("per_page") || "10"),
        limit: parseInt(searchParams.get("per_page") || "10"),
    });

    return (
        <PageWrapper pageTitle="Refund and Replacement Request" currentPage="Refund and Replacement Request">
            {/* <div className="flex items-center justify-between">
                <>
                    <DatePickerWithRange />
                </>
                <Button className="px-10">Send</Button>
            </div> */}
            <div>
                <Card className="mt-4 p-4">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                {/* <TableHead>
                                    <Checkbox />
                                </TableHead> */}
                                <TableHead>Date</TableHead>
                                <TableHead>Order ID</TableHead>
                                <TableHead>Reason</TableHead>
                                {/* <TableHead>Action</TableHead> */}
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {!isLoading &&
                                requests?.data?.map((request: any) => (
                                    <TableRow key={request.id}>
                                        {/* <TableCell className="font-medium">
                                            <Checkbox />
                                        </TableCell> */}
                                        <TableCell>{formatDate(new Date(request.created_at))}</TableCell>
                                        <TableCell className="font-bold">{request?.order_id}</TableCell>
                                        <TableCell>{request?.refund_reason}</TableCell>
                                        <TableCell>
                                            <Link to={`/app/refund-request/details/${request?.id}`} className="font-bold text-blue-600">
                                                Details
                                            </Link>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            {isLoading &&
                                [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                                    <TableRow key={item}>
                                        <TableCell className="p-4 font-medium">
                                            <Skeleton className="h-4 w-full" />
                                        </TableCell>
                                        <TableCell className="p-4">
                                            <Skeleton className="h-4 w-full" />
                                        </TableCell>
                                        <TableCell className="p-4">
                                            <Skeleton className="h-4 w-full" />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            {(isError || !requests?.data || requests?.data?.length < 1) && !isLoading && (
                                <TableRow>
                                    <TableCell colSpan={3} className="w-full text-center">
                                        <NoDataFound message="No Leads Found" />
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <>
                        <PaginationCombo totalItems={6} />
                    </>
                </Card>
            </div>
        </PageWrapper>
    );
};

export default RefundRequests;
